function ScheduledCampaignsController(
    $scope,
    $filter,
    $uibModal,
    PermissionService,
    CampaignsService,
    LocalisationService,
    ErrorService,
    notify,
    NgTableParams) {
    self.initialise = function () {

        self.userContext = PermissionService.userContext;

        if (!self.userContext) {
            return;
        }

        self.campaigns = [];

        checkUserAccessToCampaignManagement();
        loadCampaigns();
        setupTable();
    };

    var checkUserAccessToCampaignManagement = function () {
        var userCanManageCampaigns = PermissionService
            .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ManageCampaigns,
                self.userContext);
        if (!userCanManageCampaigns) {
            PermissionService.navigateToAccessDenied();
        }
    };

    var setupTable = function () {
        $scope.campaignsTableParams = new NgTableParams({
            page: 1,
            count: Dashboard.NgTableParams.InitialCount
        }, {
            getData: function (params) {
                return Dashboard.helpers.tableHelper
                    .sortAndFilter(params, $filter, self.campaigns);
            }
        });
    };

    var loadCampaigns = function () {
        $scope.$root.isLoading = true;
        CampaignsService.getScheduledCampaigns(self.userContext.StoreId, self.userContext.BrandId)
            .then(function (result) {
                self.campaigns = _.map(result.data.Campaigns, function (item) {
                    return new Dashboard.Models.Campaign().initialiseCampaignList(item, LocalisationService);
                });
                Dashboard.helpers
                    .tableHelper
                    .reloadTable($scope.campaignsTableParams,
                        self.campaigns.map(x => {
                            x.TargetSourceQueryName = getQueryNameFromTargetSource(x.TargetSourceUrl);
                            return x;
                        }));
            }, function error(result) {
                ErrorService.showError('An error occurred when loading the campaign', result);
            }).finally(function () {
            $scope.$root.isLoading = false;
        });
    };

    const getQueryNameFromTargetSource = function (targetSource) {
        if (targetSource) {
            let url = new URL(targetSource);
            let searchParams = new URLSearchParams(url.search);
            let target = searchParams.get("target");
            if (target) {
                return target;
            }
        }
        return "";
    }

    $scope.cancelCampaign = function (campaign) {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'components/campaigns/cancelcampaign/cancelcampaignmodal.7d64b189.html',
            controller: 'CancelCampaignModalController',
            backdrop: 'static',
            resolve: {
                campaign: function () {
                    return campaign;
                }
            }
        });

        modalInstance.result.then(function (result) {
            if (!result) {
                return;
            }
            CampaignsService.cancelCampaign(campaign.Id).then(function () {
                loadCampaigns();
                notify.success('The campaign was successfully cancelled');
            }, function error(result) {
                ErrorService.showError('An error occurred when attempting to cancel a campaign', result);
            })
        })

    };

    self.initialise();
}

angular
    .module('dashboard')
    .component('scheduledCampaigns', {
        templateUrl: 'components/campaigns/scheduledcampaigns/scheduledcampaigns.fa4b1736.html',
        bindings: {},
        controller: [
            '$scope',
            '$filter',
            '$uibModal',
            'PermissionService',
            'CampaignsService',
            'LocalisationService',
            'ErrorService',
            'notify',
            'NgTableParams',
            ScheduledCampaignsController
        ]
    });
